import { Autocomplete, AutocompleteOption, Chip, createFilterOptions, Icons, Typography } from '@healthinal/ui';
import { useEffect, useState } from 'react';
import { useGetMedication } from '../../../../api/generated/medication-controller/medication-controller.ts';
import { MedicationDto } from '../../../../api/generated/model';
import { CreateMedicationDialog } from './CreateMedicationDialog.tsx';

interface Props {
  onChange: (medication: MedicationDto[]) => void;
  value: MedicationDto[];
}
export function SelectMedication({ value, onChange }: Props) {
  const defaultFilterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option: MedicationDto) => option.name,
  });

  const { data: medications, isPending } = useGetMedication();

  const [isCreateMedicationDialogOpen, setIsCreateMedicationDialogOpen] = useState(false);
  const [newMedications, setNewMedications] = useState<MedicationDto[]>([]);

  const mergedMedicationList = medications ? [...medications, ...newMedications] : [];

  const filterNewMedications = (existingNewMedications: MedicationDto[], existingMedications: MedicationDto[]) => {
    return existingNewMedications.filter((med) => !existingMedications.some((existing) => existing.name === med.name));
  };

  useEffect(() => {
    if (medications) {
      setNewMedications((existingNewMedications) => filterNewMedications(existingNewMedications, medications));
    }
  }, [medications]);

  return (
    <>
      <Autocomplete
        value={value}
        onChange={(_, value) => onChange(value)}
        loading={isPending}
        multiple={true}
        options={mergedMedicationList}
        getOptionLabel={(option) => option.name}
        filterSelectedOptions
        filterOptions={(options, state) => {
          const filtered = defaultFilterOptions(options, state);
          return [...filtered, { name: 'Medikament erstellen' } as MedicationDto];
        }}
        getOptionKey={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.name === value.name}
        renderOption={(props, option) =>
          option.name !== 'Medikament erstellen' ? (
            <AutocompleteOption {...props} key={option.name}>
              {option.name}
            </AutocompleteOption>
          ) : (
            <AutocompleteOption key={option.name} onClick={() => setIsCreateMedicationDialogOpen(true)}>
              <Typography level={'title-md'}> Neues Medikament erstellen</Typography>
            </AutocompleteOption>
          )
        }
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip {...getTagProps({ index })} key={option.name} endDecorator={<Icons.Close />}>
              {option.name}
            </Chip>
          ))
        }
      />
      <CreateMedicationDialog
        open={isCreateMedicationDialogOpen}
        onClose={(medication) => {
          setIsCreateMedicationDialogOpen(false);
          if (medication) {
            setNewMedications([...newMedications, medication]);
            onChange([...value, medication]);
          }
        }}
        currentMedications={mergedMedicationList}
      />
    </>
  );
}
